// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageSection_wrapper__1dlUa","content":"ImageSection_content__2ZWSH","buttonWrapper":"ImageSection_buttonWrapper___H3Af"};